// extracted by mini-css-extract-plugin
module.exports = {"root":"PqrVg","subfolder":"_1VUu6"};